import React from 'react';
import {Alert, Button, Col, Form, FormGroup, Row} from 'react-bootstrap';
import {useDeviceSettings} from '../../hooks/useDeviceSettings';
import {Dropdown} from '../../../../shared/ui/Dropdown';

const DeviceSettings = ({eid}) => {
  const {
    loading,
    error,
    ctType,
    setCtType,
    ctPrimaryCurrent,
    setCtPrimaryCurrent,
    ctInvert,
    handleSwitchChange,
    hasChanges,
    originalCtType,
    save,
  } = useDeviceSettings(eid);

  return (
    <>
      {error && <Alert variant="warning" className="mb-3">{error}</Alert>}
      <div className="island p-4">
        <Row className="g-4">
          <Col md={6}>
            <FormGroup className="mb-3">
              <Form.Label className="small" style={{color: 'var(--text-secondary)'}}>Transformer Type</Form.Label>
              <Dropdown
                options={[
                  {value: 'YHDC_SCT013', label: '100A/50mA (Standard Transducer)'},
                  {value: 'X/1A', label: 'X/1A (Custom)'},
                ]}
                value={ctType}
                onChange={(val) => setCtType(val)}
                block
              />
            </FormGroup>
            {ctType === 'X/1A' && (
              <FormGroup className="mb-3">
                <Form.Label className="small" style={{color: 'var(--text-secondary)'}}>Primary Current (A)</Form.Label>
                <Form.Control
                  type="number"
                  value={ctPrimaryCurrent}
                  onChange={(e) => setCtPrimaryCurrent(e.target.value)}
                  style={{
                    backgroundColor: 'var(--input-bg)',
                    color: 'var(--text-primary)',
                    borderColor: 'var(--border-color)',
                  }}
                />
              </FormGroup>
            )}
            {ctType !== originalCtType && (
              <Alert variant="warning" className="d-flex align-items-center mt-3 py-2 px-3"
                     style={{fontSize: '0.9rem'}}>
                <span>⚠️ The transformer type must be adjusted with a jumper on the controller!</span>
              </Alert>
            )}
          </Col>
          <Col md={6}>
            <Form.Label className="small d-block mb-3" style={{color: 'var(--text-secondary)'}}>
              Current Direction (Invert Phases)
            </Form.Label>
            <div className="d-flex flex-column gap-2">
              {[0, 1, 2].map((phaseIndex) => (
                <div
                  key={phaseIndex}
                  className="d-flex align-items-center justify-content-between p-2 rounded"
                  style={{backgroundColor: 'var(--bg-secondary)'}}
                >
                  <span style={{color: 'var(--text-primary)', fontSize: '0.95rem'}}>Phase {phaseIndex + 1}</span>
                  <Form.Check
                    type="switch"
                    id={`phase-${phaseIndex}`}
                    checked={ctInvert[phaseIndex] !== "0"}
                    onChange={() => handleSwitchChange(phaseIndex)}
                    style={{cursor: 'pointer'}}
                  />
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="d-flex justify-content-end">
            {loading ? (
              <Button disabled variant="primary"
                      style={{backgroundColor: 'var(--blue)', borderColor: 'var(--blue)', opacity: 0.7}}>
                Saving...
              </Button>
            ) : (
              <Button
                onClick={save}
                disabled={!hasChanges}
                variant="primary"
                style={{
                  backgroundColor: 'var(--blue)',
                  borderColor: 'var(--blue)',
                  opacity: hasChanges ? 1 : 0.6,
                }}
              >
                Save Configuration
              </Button>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DeviceSettings;
